import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faGaugeSimpleHigh, faBuilding } from '@fortawesome/free-solid-svg-icons';

const Navigation = ({ 
  currentView, 
  user, 
  switchToView, 
  updateActivity,
  selectedBuilding,
  setSelectedBuilding, 
  setProfileModalOpen 
}) => (
  <nav className="nav-primary p-4 shadow-lg">
    <div className="container mx-auto">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center space-x-4">
          <img 
            src="/fastplanet-logo.svg" 
            alt="FASTPLANET Logo" 
            className="h-16"
            style={{ filter: 'brightness(0) saturate(100%) invert(100%)' }}
          />
          <span className="text-2xl font-bold">Glasfaser Dokumentation</span>
        </div>
        
        {/* User Profile Icon */}
        <div className="relative">
          <button
            onClick={() => setProfileModalOpen(true)}
            className="flex items-center space-x-2 text-white hover:text-orange-200 transition-colors"
            title={`Angemeldet als ${user?.fullName || user?.username}`}
          >
            <FontAwesomeIcon icon={faUser} className="text-xl" />
            <span className="hidden md:block text-sm">
              {user?.fullName || user?.username}
            </span>
          </button>
        </div>
      </div>
      
      <div className="border-b" style={{ borderColor: '#DE8936' }}>
        <div className="flex space-x-0">
          <button
            onClick={() => {
              switchToView('dashboard');
              updateActivity();
            }}
            className={`nav-link px-6 py-3 font-medium text-sm border-b-3 ${
              currentView === 'dashboard' ? 'active' : ''
            }`}
          >
            <FontAwesomeIcon icon={faGaugeSimpleHigh} className="mr-2" />
            Dashboard
          </button>
          <button
            onClick={() => {
              switchToView('buildings');
              updateActivity();
            }}
            className={`nav-link px-6 py-3 font-medium text-sm border-b-3 ${
              currentView === 'buildings' ? 'active' : ''
            }`}
          >
            <FontAwesomeIcon icon={faBuilding} className="mr-2" />
            Gebäudedetails
          </button>
          <button
            onClick={() => {
              setSelectedBuilding(null);
              switchToView('building-form');
              updateActivity();
            }}
            disabled={true}
            className={`nav-link px-6 py-3 font-medium text-sm border-b-3 ${
              currentView === 'building-form' ? 'active' : ''
            } ${currentView !== 'building-form' ? 'opacity-40 cursor-not-allowed' : 'hover:opacity-90'}`}
          >
            Gebäude
          </button>
        </div>
      </div>
    </div>
  </nav>
);

export default Navigation;